import React from 'react'

import { Box } from '~/components/elements/Box'
import { Suspense } from '~/components/elements/Suspense'
import { ZStack } from '~/components/elements/ZStack'
import { nineNumbers } from '~/utils'

import { useIsTabulationFetching } from '../../hooks/useTabulationQuery'

import { Arrows } from './Arrows'
import { NineNumberCell } from './NineNumberCell'
import styles from './StrategyPanel.css'

export type StrategyPanelProps = {
  index: number
}

export const StrategyPanel = React.forwardRef<
  HTMLDivElement,
  StrategyPanelProps
>(({ index }, ref) => {
  const isTabulationFetching = useIsTabulationFetching()

  return (
    <ZStack ref={ref} className={styles.root}>
      <Suspense loading={isTabulationFetching} loadingContainerSize="mini">
        <Box className={styles.panel}>
          {nineNumbers.map((nineNumber) => (
            <NineNumberCell
              key={nineNumber}
              index={index}
              nineNumber={nineNumber}
            />
          ))}
        </Box>

        <Arrows index={index} />
      </Suspense>
    </ZStack>
  )
})
